import React, { useState, useEffect } from 'react';
import { Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import './EditHeader.scss'; // Assuming you have a separate CSS file for styles

function EditHeader({ isOpen, toggle, header, onSubmit }) {
  const [headerTitle, setHeaderTitle] = useState('');

  useEffect(() => {
    if (isOpen && header?.Title) {
      setHeaderTitle(header.Title);
    } else if (!isOpen) {
      setHeaderTitle('');
    }
  }, [isOpen, header]);

  const handleUpdate = () => {
    if (!headerTitle.trim()) {
      toast.error('Header name is required', {
        className: 'toast-error',
      });
      return;
    }

    // Call the onSubmit function passed as prop
    onSubmit({
      headerId: header?.HeaderId,
      title: headerTitle,
    });
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <div className="modal-header-custom px-4 pt-3 pb-2 d-flex justify-content-between align-items-center">
        <h5 className="modal-title mb-0">Update Header</h5>
        <Icon
          path={mdiClose}
          size={1}
          color="#000000"
          onClick={toggle}
          className="cursor-pointer"
        />
      </div>
      <ModalBody>
        <div>
          <Label>
            Header<span className="text-danger">*</span>
          </Label>
          <Input
            placeholder="Enter header name here"
            type="text"
            value={headerTitle}
            onChange={e => setHeaderTitle(e.target.value)}
            className="external-filter-input"
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="custom-btn text-center w-100"
          onClick={handleUpdate}
        >
          Update Header
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default EditHeader;
